import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';

/**
 * Returns the effective state of the Salesforce ECA migration.
 *
 * The migration is driven by the `cdp_salesforce_eca_migration` flag, but an
 * account can opt back out via `cdp_salesforce_eca_migration_optout`. When the
 * opt-out flag is on, the migration is treated as off regardless of the
 * migration flag — callers get a single boolean and never have to combine the
 * two flags themselves.
 */
export function useSalesforceEcaMigrationEnabled(): boolean {
  const migrationOn = useFeatureFlag(AccountFeatureFlag.CdpSalesforceEcaMigration);
  const optedOut = useFeatureFlag(AccountFeatureFlag.CdpSalesforceEcaMigrationOptout);
  return migrationOn && !optedOut;
}
